import { Loader2 } from 'lucide-react';

export function PageLoadingIndicator() {
  return (
    <div className="fixed inset-0 bg-white bg-opacity-75 flex flex-col items-center justify-center z-50">
      <div className="flex flex-col items-center space-y-4">
        <Loader2 className="h-12 w-12 animate-spin text-primary" />
        <p className="text-gray-700 font-medium text-lg">Chargement...</p>
      </div>
    </div>
  );
}
